/* =========================================================================== */
// from Copilot; improved code with event delegation and bubbling

document.addEventListener("DOMContentLoaded", function () {
  //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // Modify form tag - remove 'novalidate' attribute - START ------------------
  var form = document.querySelector("form[novalidate]");
  if (form) {
    form.removeAttribute("novalidate");
  }
  // modify form tag - remove 'novalidate' attribute - END ------------------

  //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  //------------- For Earrings, Neackace, Neckace & Earrings Varaint Selection - START-----------
  var variantSelect = document.querySelector('select[id^="Option"]');

  if (variantSelect) {
    // Add event listener for change events
    document.addEventListener("change", function (event) {
      //console.log("Change event detected");
      //console.log(variantSelect);
      if (event.target.matches('select[id^="Option"]')) {
        const targetValues = [
          "earrings only",
          "necklace only",
          "necklace + earrings",
        ];
        //var sel = variantSelect;
        var sel = event.target;
        for (let i = 0; i < sel.options.length; i++) {
          const optionValue = sel.options[i].value;

          // Check if the option value matches any of the target values
          if (targetValues.includes(optionValue)) {
            // Assign the select element to the variable variantSelect
            variantSelect = sel;
            var selectedVariant =
              event.target.options[event.target.selectedIndex].text;
            var ajNecklaceSelect = document.querySelector(
              'select[id^="nlength"]'
            );
            var ajNecklaceWrapperSelect = document.querySelector(
              ".aj-nlength-wrapper"
            );

            if (selectedVariant.toLowerCase() == "earrings only") {
              ajNecklaceSelect.removeAttribute("required");
              ajNecklaceSelect.disabled = true;
              ajNecklaceWrapperSelect.style.display = "none";
            } else {
              ajNecklaceWrapperSelect.style.display = "block";
              ajNecklaceSelect.disabled = false;
              ajNecklaceSelect.setAttribute("required", "required");
            }
            break;
          }
        }
      } // if (event.target.matches('select[id^="Option"]'))
    }); // document.addEventListener("change", function (event) {

    // Set default selection to "earrings only"
    variantSelect.value = "earrings only";

    // Trigger change event on page load to set initial state
    var event = new Event("change", { bubbles: true });
    variantSelect.dispatchEvent(event);
  } // if (variantSelect)
  //------------- for Earrings, Neackace, Neckace & Earrings Variant Selection - END-----------

  //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // To show/hide Pop-up Size Chart, Color Chart, Message Cards / and Sample Packaging Accordion - START ------------------
  //*** Pop-ups (Size Chart, Color Chart, Message Cards)
  const colorCharts = document.querySelectorAll(".color-chart-display"); // Replace with appropriate selector
  const sizeCharts = document.querySelectorAll(".size-chart-display"); // Replace with appropriate selector
  const sampleMessages = document.querySelectorAll(".sample-message-display"); // Replace with appropriate selector
  const buttons = document.querySelectorAll(".product-popup-modal__button");

  buttons.forEach((button) => {
    const opener = button.closest(".product-popup-modal__opener");

    switch (button.textContent.trim()) {
      case "Color Charts":
        opener.style.display = colorCharts.length > 0 ? "inline" : "none";
        break;
      case "Size Chart":
        opener.style.display = sizeCharts.length > 0 ? "inline" : "none";
        break;
      case "Sample Messages":
        opener.style.display = sampleMessages.length > 0 ? "inline" : "none";
        break;
      default:
      // Do nothing for other buttons
    }
  });

  //*** Accordions (Sample Packaging)
  const samplePackagingPic = document.getElementById("sample-packaging-pic");
  const accordion = samplePackagingPic.closest("div.accordion");

  if (samplePackagingPic.classList.contains("sample-packaging-pic-display")) {
    accordion.style.display = "block"; // Show the specific accordion if the sample-packaging-pic is present
  } else {
    accordion.style.display = "none"; // Hide the specific accordion if the sample-packaging-pic is not present
  }

  // to show/hide Pop-up Size Chart, Color Chart, Message Cards / and Sample Packaging Accordion - END ------------------

  //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // For Got a Question feature in the product page - START------------------------
  var contactFields = document.querySelector(".contact__fields");

  if (contactFields) {
    //var productUrl = "{{ product.url }}";
    var productUrl = window.location.href;

    // Create the div container
    var divContainer = document.createElement("div");
    divContainer.setAttribute("class", "field");

    // Create the label
    var label = document.createElement("label");
    label.setAttribute("for", "ContactForm-product");
    label.setAttribute("class", "field__label");
    label.textContent = "Product";

    // Create the textbox
    var input = document.createElement("input");
    input.setAttribute("type", "text");
    input.setAttribute("id", "ContactForm-product");
    input.setAttribute("name", "contact[Product]");
    input.setAttribute("value", productUrl);
    input.setAttribute("readonly", true);
    input.setAttribute("class", "field__input product-url-input");
    /*input.setAttribute("disabled", "disabled");*/

    // Append label and input to the div container
    divContainer.appendChild(input);
    divContainer.appendChild(label);

    // Insert the div container before the contact__fields div
    contactFields.parentNode.insertBefore(divContainer, contactFields);
  }

  /*  insert the Product url in the textarea and make it non-editable
  var textArea = document.getElementById("ContactForm-body");
  if (textArea) {
    var productUrl = window.location.href;
    textArea.value = productUrl + "\n\n" + textArea.value;
    textArea.addEventListener("input", function () {
      var lines = textArea.value.split("\n");
      if (lines[0] !== productUrl) {
        lines[0] = productUrl;
        textArea.value = lines.join("\n");
      }
    });
  }
*/
  // for Got a Question feature in the product page - END------------------------
}); //("DOMContentLoaded", function ()

/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

//++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// Message card option - START ------------------------------------------------------
var msgCardOption = document.getElementById("message-card-option");

if (msgCardOption) {
  msgCardOption.addEventListener("change", messageCardOption);

  function messageCardOption() {
    var mco = document.getElementById("message-card-option");
    var ajcct = document.getElementById("aj-custom-card-text");
    var cmti = document.getElementById("custom-message-text-input");
    if (
      mco.value.toLowerCase() == "blank card - no message" ||
      mco.value.toLowerCase() == "" ||
      mco.value.toLowerCase() == "as pictured"
    ) {
      // don't show any text input
      ajcct.classList.add("hidden");
      cmti.removeAttribute("required", "required");
      cmti.disabled = true;
    } else {
      // show text input
      // first, make sure to enable the input, in case it was disabled,  and then require
      cmti.disabled = false;
      cmti.setAttribute("required", "required");
      cmti.value = "";

      // then show
      ajcct.classList.remove("hidden");
      cmti.setAttribute(
        "placeholder",
        "Write Custom message or Code from chart here..."
      );
    }
  }
}
// Message card option - END ------------------------------------------------------
